import { RequestItemsSchema } from '@liscio/api';

export const findSignableItem = (items: RequestItemsSchema[]) => {
  return items.find((item) => {
    return item.item_type === 'signable_document';
  });
};
